import React from 'react';
import Anchor from '@om-fe/core/components/anchor/anchor';
import { BemMethod, createBem } from '@om-fe/utils';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { RouteNames } from '@om-fe/core/core/routing/utils';

interface EmptyMatchMessageProps {
    readonly message: string;
}

const bem: BemMethod = createBem('EmptyMatchMessage');

export function EmptyMatchMessage ({message}:EmptyMatchMessageProps,) {
    const { gettext } = useI18NContext();

    return (
        <div className={bem()}>
            <p>{message}</p>
            <p>{gettext('Please return to the homepage and try again later.')}</p>
            <Anchor routeName={RouteNames.home}>
                <button className={bem('HomeButton')}>
                    {gettext('Go to homepage')}
                </button>
            </Anchor>
        </div>
    )
}
